module.exports = __webpack_public_path__ + "static/media/BBE_Standard_logo.62b9f64e.png";